<template lang="pug">
#graficoAreaColhida
    div(v-show='possuiDadosHistoricos')
        apex-charts.component.apexcharts-canvas(
            type='bar',
            height='300',
            ref='chart',
            :options='options',
            :series='series'
        )

    div(v-show='!possuiDadosHistoricos')
        empty-result(
            :min-height='150',
            icon-class='mdi-alert-octagon',
            :message="$t('mensagens.monitoramento.historico.agricola.aindaNaoForamObtidosDados')"
        )
</template>

<script>
import ApexCharts from 'vue-apexcharts';
import EmptyResult from '@/components/EmptyResult';

import formatters from '@/utils/formatters';

export default {
    name: 'GraficoAreaColhida',
    components: {
        ApexCharts,
        EmptyResult
    },

    props: {
        dadosHistorico: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            series: [],
            options: {
                legend: {
                    position: 'top',
                    onItemClick: {
                        toggleDataSeries: true
                    }
                },
                chart: {
                    toolbar: {
                        show: false
                    }
                },
                plotOptions: {
                    bar: {
                        borderRadius: 2,
                        columnWidth: '25%'
                    }
                },
                xaxis: {
                    categories: []
                },
                colors: [
                    '#9CCC65',
                    '#FFEE58',
                    '#978289',
                    '#DC610D'
                ],
                stroke: {
                    colors: ['transparent'],
                    width: 6
                },
                yaxis: [
                    {
                        showAlways: true,
                        seriesName: `${this.$t('mensagens.monitoramento.historico.agricola.areaColhida')} (ha)`,
                        labels: {
                            formatter: value => {
                                return value ? value.toFixed(0) : 0;
                            }
                        },
                        min: 0,
                        max(max) {
                            return max + 20;
                        }
                    }
                ],
                tooltip: {
                    y: {
                        formatter: value => {
                            return formatters.formatNumber(value, 2) + ' ha';
                        }
                    }
                },
                dataLabels: {
                    // style: {
                    //     colors: ['#333', '#333', '#333', '#333']
                    // },
                    formatter: value => {
                        return formatters.formatNumber(value, 2);
                    },
                    enabled: false
                }
            }
        };
    },

    methods: {
        updateGrafico() {
            this.options.xaxis.categories = this.dadosHistorico.map(d => this.parseSafraDescription(d.safra.descricao));

            let series = [];

            // let nomesCulturas = new Set(this.dadosHistorico.map(d => d.cultura.nome).sort().reverse());
            // Desculpa =(
            let nomesCulturas = ['Soja', 'Milho', 'Algodão', 'Outros'];
            nomesCulturas.forEach(nomeCultura => {
                let dadosPorCultura = this.dadosHistorico.map(d => {
                    const historicoCultura = d.historicosAgro.find(
                        h => h.cultura.nome === nomeCultura
                    );
                    if (historicoCultura) return historicoCultura.areaColhidaHa;
                    return 0.0;
                });
                series.push({
                    name: this.internacionalizarCulturas(nomeCultura),
                    type: 'column',
                    data: dadosPorCultura
                });
            });

            this.series = series;

            this.$refs.chart.updateOptions(this.options, true);
        },
        internacionalizarCulturas(cultura) {
            const culturaFormatada = cultura.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
            const culturaFormatadaSemEspacos = culturaFormatada.replace(/\s+/g, '-');
            return this.$t(`mensagens.cultura.${culturaFormatadaSemEspacos}`);
        },
        parseSafraDescription(desc) {
            const safraRegex = /^(Safra|Safrinha)\s(\d{2}\/\d{2})$/;
            const match = desc.match(safraRegex);

            if (match) {
                const [ , type, years] = match;
                const key = type === 'Safra' ? 'mensagens.monitoramento.historico.agricola.safra' : 'mensagens.monitoramento.historico.agricola.safrinha';
                return this.$t(key) + ' ' + years;
            }

            return this.$t('mensagens.monitoramento.historico.agricola.safra');
        }
    },

    mounted() {
        this.updateGrafico();
    },

    watch: {
        dadosHistorico() {
            this.updateGrafico();
        }
    },

    computed: {
        possuiDadosHistoricos() {
            return this.dadosHistorico && this.dadosHistorico.length > 0;
        }
    }
};
</script>

<style>
.apexcharts-tooltip {
    background-color: white;
    border: 1px solid #e3e3e3;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    padding: 5px;
}

.apexcharts-tooltip .apexcharts-tooltip-title {
    background: #fff !important;
    align-self: flex-start;
    font-family: Arial, Helvetica, sans-serif;
    color: #333;
    border-bottom: 0px !important;
    font-weight: 600;
    font-size: 14px !important;
    padding: 5px;
    border-radius: 5px 5px 0 0;
}

.apexcharts-tooltip .apexcharts-tooltip-series-group {
    padding: 5px;
    display: flex;
    align-items: center;
}

.apexcharts-tooltip .apexcharts-tooltip-marker {
    width: 10px;
    height: 10px;
    margin-right: 5px;
}

.apexcharts-tooltip .apexcharts-tooltip-text {
    font-size: 12px;
    color: #333;
}

.apexcharts-tooltip .apexcharts-tooltip-text-y-label,
.apexcharts-tooltip .apexcharts-tooltip-text-y-value {
    display: inline-block;
}
</style>
